<template>
  <a-modal
    :title="formTitle || '新增项目'"
    v-model:visible="open"
    @cancel="onClose"
    :width="1100"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form 
      ref="formRef" 
      :model="form" 
      :rules="rules"
      :label-col="{ flex: '0 0 200px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目分组" name="projectGroup">
            <a-input
              v-model:value="form.projectGroup"
              placeholder="请输入项目分组"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="项目代码" name="projectCode">
            <a-input
              v-model:value="form.projectCode"
              placeholder="请输入项目代码"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="中文项目名称" name="chineseName">
            <a-input
              v-model:value="form.chineseName"
              placeholder="请输入中文项目名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="英文名称" name="englishName">
            <a-input
              v-model:value="form.englishName"
              placeholder="请输入英文名称"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目主管" name="supervisorId">
            <a-select
              v-model:value="form.supervisorId"
              show-search
              :filter-option="filterSupervisorOption"
              placeholder="请搜索选择项目主管"
              style="width: 100%"
              allow-clear
              :loading="supervisorLoading"
              @change="handleSupervisorChange"
            >
              <a-select-option
                v-for="user in supervisorList"
                :key="user.id"
                :value="user.id"
              >
                {{ user.nickName }} ({{ user.userName }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="项目当前状态" name="projectStatus">
            <a-select
              v-model:value="form.projectStatus"
              placeholder="请选择项目状态"
              style="width: 100%"
              allow-clear
            >
              <a-select-option
                v-for="(d, index) in dictProjectStatus"
                :key="d.dictValue"
                :value="d.dictValue"
                >{{ d.dictLabel }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="甲方联系人" name="leader">
            <a-input v-model:value="form.leader" placeholder="请输入甲方联系人" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="甲方联系电话" name="phone">
            <a-input
              v-model:value="form.phone"
              :disabled="formType === 2 && !!form.phone"
              placeholder="请输入甲方联系电话"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="甲方登录密码" name="password">
            <a-input
              v-model:value="form.password"
              placeholder="请输入甲方登录密码"
            />
            <!-- <div style="color: #999; font-size: 12px; margin-top: 4px">
              <template v-if="formType == 1"> </template>
              <template v-else>
                提示：不填写不修改密码保持原密码，填写了则为新密码
              </template>
            </div> -->
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="是否启用自动计薪" name="needSalary">
            <a-select
              v-model:value="form.needSalary"
              placeholder="请选择是否启用自动计薪"
              style="width: 100%"
              allow-clear
            >
              <a-select-option
                v-for="(d, index) in dictWhetherToCalculateSalary"
                :key="d.dictValue"
                :value="d.dictValue"
                >{{ d.dictLabel }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目开始时间" name="startTime">
            <a-date-picker
              v-model:value="form.startTime"
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择项目开始时间"
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="项目合同到期时间" name="endTime">
            <a-date-picker
              v-model:value="form.endTime"
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择项目合同到期时间"
              allow-clear
              :disabled-date="disabledEndDate"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目情况描述" name="description">
            <a-input
              v-model:value="form.description"
              placeholder="请输入内容"
              type="textarea"
              allow-clear
              :style="{ width: '100%', maxWidth: 'calc(100% - 20px)' }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="项目地址" name="address">
            <div class="address-input-wrapper">
              <a-input
                v-model:value="form.address"
                :disabled="true"
                readonly
                placeholder="请选择项目地址"
                class="address-input"
              />
              <a-button type="primary" class="map-picker-btn" @click="openMapPicker">
                <EnvironmentOutlined />地图选点
              </a-button>
            </div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="经度" name="longitude">
            <a-input
              v-model:value="form.longitude"
              :disabled="true"
              placeholder="自动填入"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="维度" name="latitude">
            <a-input
              v-model:value="form.latitude"
              :disabled="true"
              placeholder="自动填入"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="APP名字" name="fmapApp">
            <a-input v-model:value="form.fmapApp" placeholder="请输入APP名字" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="fmap开发者KEY" name="fmapKey">
            <a-input
              v-model:value="form.fmapKey"
              placeholder="请输入fmap开发者KEY"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="fmap开发者key-安卓" name="fmapKeyAnd">
            <a-input
              v-model:value="form.fmapKeyAnd"
              placeholder="请输入fmap开发者key-安卓"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="fmap开发者key-IOS" name="fmapKeyIos">
            <a-input
              v-model:value="form.fmapKeyIos"
              placeholder="请输入fmap开发者key-IOS"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="mapId" name="fmapMapId">
            <a-input v-model:value="form.fmapMapId" placeholder="请输入mapId" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="主体ID" name="fmapSubjectId">
            <a-input
              v-model:value="form.fmapSubjectId"
              placeholder="请输入主体ID"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="空间任务采集最小时长(分钟)" name="spaceMinDuration">
            <a-input-number
              v-model:value="form.spaceMinDuration"
              :min="0"
              :precision="0"
              :step="1"
              style="width: 100%"
              placeholder="请输入空间任务采集最小时长(分钟)"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="机动任务采集最小时长(分钟)" name="motorizedMinDuration">
            <a-input-number
              v-model:value="form.motorizedMinDuration"
              :min="0"
              :precision="0"
              :step="1"
              style="width: 100%"
              placeholder="请输入机动任务采集最小时长(分钟)"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="AI采集最小时长(分钟)" name="aiMinDuration">
            <a-input-number
              v-model:value="form.aiMinDuration"
              :min="0"
              :precision="0"
              :step="1"
              style="width: 100%"
              placeholder="请输入AI采集最小时长(分钟)"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="项目公司图片" name="url">
        <file-upload
          :value="form.url"
          type="image"
          :count="9"
          field-name="url"
          @change="handleUrlChange"
        />
      </a-form-item>
      <!--      <a-form-model-item label="是否显示 1显示 0-不显示" prop="status" >-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="排序" prop="sort" >-->
      <!--        <a-input v-model="form.sort" placeholder="请输入排序" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
    <!-- 地图选点弹窗 -->
    <map-picker
      :visible="mapPickerVisible"
      :longitude="form.longitude"
      :latitude="form.latitude"
      :address="form.address"
      @confirm="handleMapPickerConfirm"
      @cancel="closeMapPicker"
    />
  </a-modal>
</template>

<script setup>
import { EnvironmentOutlined } from '@ant-design/icons-vue'
import { reactive, ref, onMounted, watch } from 'vue'
import { getProjectInfo, addProjectInfo, updateProjectInfo } from '@/api/user/projectInfo'
import { listUser } from '@/api/system/user'
import { getDicts } from '@/api/system/dict/data'
import MapPicker from './MapPicker'

defineOptions({
  name: 'CreateForm',
})

defineProps({})
const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const mapPickerVisible = ref(false)
const supervisorList = ref([])
const supervisorLoading = ref(false)
const formType = ref(1)
const open = ref(false)

// 字典数据
const dictProjectStatus = ref([])
const dictWhetherToCalculateSalary = ref([])

// 初始化字典
const initDicts = async () => {
  try {
    const [projectStatusRes, whetherToCalculateSalaryRes] = await Promise.all([
      getDicts('project_status').catch(() => ({ data: [] })),
      getDicts('whether_to_calculate_salary').catch(() => ({ data: [] }))
    ])
    dictProjectStatus.value = projectStatusRes.data || []
    dictWhetherToCalculateSalary.value = whetherToCalculateSalaryRes.data || []
  } catch (error) {
    console.error('初始化字典失败:', error)
  }
}

const form = reactive({
  id: null,
  projectCode: null,
  projectGroup: null,
  chineseName: null,
  englishName: null,
  companyId: null,
  companyCode: null,
  companyAbbreviation: null,
  supervisorId: null,
  supervisorName: null,
  isInstallments: null,
  description: null,
  address: null,
  leader: null,
  phone: null,
  startTime: null,
  endTime: null,
  needSalary: '0',
  longitude: null,
  latitude: null,
  projectStatus: '0',
  fmapApp: null,
  fmapKey: null,
  fmapKeyAnd: null,
  fmapKeyIos: null,
  fmapMapId: null,
  fmapSubjectId: null,
  url: null,
  aiMinDuration: null,
  motorizedMinDuration: null,
  spaceMinDuration: null,
  status: 1,
  sort: null,
  createTime: null,
  remark: null,
})

const rules = {
  // sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
  projectCode: [{ required: true, message: '项目代码不能为空', trigger: 'blur' }],
  // projectGroup: [{ required: true, message: '项目分组不能为空', trigger: 'blur' }],
  chineseName: [{ required: true, message: '中文项目名称不能为空', trigger: 'blur' }],
  // englishName: [{ required: true, message: '英文名称不能为空', trigger: 'blur' }],
  // projectStatus: [{ required: true, message: '项目当前状态不能为空', trigger: 'change' }],
  // startTime: [{ required: true, message: '项目开始时间不能为空', trigger: 'change' }],
  // endTime: [
  //   { required: true, message: '项目合同到期时间不能为空', trigger: 'change' },
  //   {
  //     validator: (rule, value) => {
  //       if (!value || !form.startTime) return Promise.resolve()
  //       const startTime = new Date(form.startTime)
  //       const endTime = new Date(value)
  //       if (endTime <= startTime) {
  //         return Promise.reject(new Error('项目合同到期时间必须在项目开始时间之后'))
  //       }
  //       return Promise.resolve()
  //     },
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  // needSalary: [{ required: true, message: '是否启用自动计薪不能为空', trigger: 'change' }],
  // fmapApp: [{ required: true, message: 'APP名字不能为空', trigger: 'blur' }],
  // fmapKey: [{ required: true, message: 'fmap开发者KEY不能为空', trigger: 'blur' }],
  // fmapKeyAnd: [{ required: true, message: 'fmap开发者key-安卓不能为空', trigger: 'blur' }],
  // fmapKeyIos: [{ required: true, message: 'fmap开发者key-IOS不能为空', trigger: 'blur' }],
  // fmapMapId: [{ required: true, message: 'mapId不能为空', trigger: 'blur' }],
  // fmapSubjectId: [{ required: true, message: '主体ID不能为空', trigger: 'blur' }],
  // spaceMinDuration: [{ required: true, message: '空间任务采集最小时长不能为空', trigger: 'blur' }],
  // motorizedMinDuration: [{ required: true, message: '机动任务采集最小时长不能为空', trigger: 'blur' }],
  // aiMinDuration: [{ required: true, message: 'AI采集最小时长不能为空', trigger: 'blur' }],
  // phone: [
  //   { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号码', trigger: 'blur' },
  // ],
}

// 加载主管列表：仅本公司在职、启用的项目主管
function loadSupervisorList() {
  supervisorLoading.value = true
  listUser({ userType: 'xmzg', status: 1, userStatus: '1' })
    .then((response) => {
      let list = []
      if (response.data && Array.isArray(response.data)) {
        list = response.data
      } else if (response.data && response.data.records) {
        list = response.data.records
      }
      list = Array.isArray(list) ? list : []
      list = list.filter((user) => user && (user.userStatus === '1' || user.userStatus === 1))
      const currentId = form.supervisorId
      if (currentId && !list.some((user) => String(user.id) === String(currentId))) {
        list = [
          {
            id: currentId,
            nickName: form.supervisorName || '当前主管',
            userName: '',
          },
          ...list,
        ]
      }
      supervisorList.value = list
    })
    .catch(() => {
      supervisorList.value = []
      window.$message?.warning?.('加载主管列表失败，请重试')
    })
    .finally(() => {
      supervisorLoading.value = false
    })
}

function handleSupervisorChange(value) {
  if (!value) {
    form.supervisorId = null
    form.supervisorName = null
    return
  }
  const user = supervisorList.value.find((u) => String(u.id) === String(value))
  form.supervisorName = user ? user.nickName : null
}

function filterSupervisorOption(input, option) {
  if (!input) {
    return true
  }
  const value = option?.value
  const user = supervisorList.value.find((u) => String(u.id) === String(value))
  const text = user
    ? `${user.nickName || ''} ${user.userName || ''}`
    : String(option?.children || '')
  return text.toLowerCase().includes(String(input).toLowerCase().trim())
}

// 监听模态框打开，加载主管列表
watch(open, (newVal) => {
  if (newVal) {
    loadSupervisorList()
  }
})

function disabledEndDate(current) {
  if (!form.startTime) {
    return false
  }
  const startTime = new Date(form.startTime)
  return current && current < startTime
}

function openMapPicker() {
  mapPickerVisible.value = true
}

function handleMapPickerConfirm(data) {
  form.longitude = data.longitude
  form.latitude = data.latitude
  form.address = data.address
  closeMapPicker()
}

function closeMapPicker() {
  mapPickerVisible.value = false
}

function handleUrlChange(data) {
  if (typeof data === 'object' && data !== null) {
    if (data.url !== undefined) {
      form.url = data.url
    }
  } else if (typeof data === 'string') {
    form.url = data
  }
}

function onClose() {
  open.value = false
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    projectCode: null,
    projectGroup: null,
    chineseName: null,
    englishName: null,
    companyId: null,
    companyCode: null,
    companyAbbreviation: null,
    supervisorId: null,
    supervisorName: null,
    isInstallments: null,
    description: null,
    address: null,
    leader: null,
    phone: null,
    startTime: null,
    endTime: null,
    needSalary: '0',
    longitude: null,
    latitude: null,
    projectStatus: '0',
    fmapApp: null,
    fmapKey: null,
    fmapKeyAnd: null,
    fmapKeyIos: null,
    fmapMapId: null,
    fmapSubjectId: null,
    url: null,
    aiMinDuration: null,
    motorizedMinDuration: null,
    spaceMinDuration: null,
    status: 1,
    sort: null,
    createTime: null,
    remark: null,
  })
}

function handleAdd() {
  reset()
  formType.value = 1
  formTitle.value = '添加'
  open.value = true
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getProjectInfo({ id }).then((response) => {
    Object.assign(form, response.data || {})
    open.value = true
    formTitle.value = '修改'
  })
}

function submitForm() {
  formRef.value?.validate().then((valid) => {
    if (!valid) return
    if (!form.supervisorId) {
      form.supervisorId = null
      form.supervisorName = null
    }
    submitLoading.value = true
    const req = form.id !== undefined && form.id !== null ? updateProjectInfo(form) : addProjectInfo(form)
    req
      .then(() => {
        window.$message?.success?.(form.id ? '修改成功' : '新增成功', 3)
        open.value = false
        emit('ok')
      })
      .catch((error) => {
        // 使用弹窗显示错误信息，而不是在页面蒙层显示
        // 阻止错误继续向上传播，避免触发 webpack-dev-server 的错误覆盖层
        try {
          let errorMessage = '操作失败'
          if (error && error.response && error.response.data) {
            const data = error.response.data
            if (data.msg) {
              errorMessage = String(data.msg)
            } else if (data.message) {
              errorMessage = String(data.message)
            } else if (typeof data === 'string') {
              errorMessage = data
            } else if (data && typeof data === 'object') {
              // 如果是对象，尝试转换为字符串
              errorMessage = JSON.stringify(data) || '操作失败'
            }
          } else if (error && error.message) {
            errorMessage = String(error.message)
          } else if (typeof error === 'string') {
            errorMessage = error
          } else if (error && typeof error === 'object') {
            // 如果是对象，尝试转换为字符串
            errorMessage = JSON.stringify(error) || '操作失败'
          }
          window.$message?.error?.(errorMessage, 3)
        } catch (e) {
          // 如果提取错误信息时出错，使用默认错误信息
          window.$message?.error?.('操作失败，请稍后重试', 3)
        }
        // 返回一个已解决的 Promise，阻止错误继续向上传播
        return Promise.resolve()
      })
      .finally(() => {
        submitLoading.value = false
      })
  }).catch(() => {
    // 表单验证失败，不显示错误
    return false
  })
}

// 初始化
initDicts()

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>

<style scoped>
.create-form-modal :deep(.ant-modal-body) {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 16px 100px 16px !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.create-form-modal :deep(.ant-form-item) {
  margin-bottom: 16px;
}

.create-form-modal :deep(.ant-form-item-label) {
  padding-bottom: 6px;
  flex: 0 0 200px !important;
  max-width: 200px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-label) {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  text-align: right;
  padding-right: 8px !important;
  flex: 0 0 200px !important;
}

.two-column-form :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: clip !important;
  line-height: 1.5 !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 13px !important;
  letter-spacing: -0.2px;
}

.two-column-form :deep(.ant-form-item-control) {
  flex: 1;
  min-width: 0;
}

/* 调整输入框宽度 */
.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-select),
.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-tree-select),
.two-column-form :deep(.ant-input-number),
.two-column-form :deep(.ant-input-number-input),
.two-column-form :deep(textarea.ant-input) {
  width: 100%;
  min-width: 120px;
  max-width: calc(100% - 20px);
}

/* 排除项目地址输入框（需要特殊处理） */
.two-column-form :deep(.ant-input-group:not(.compact) .ant-input) {
  width: 100%;
  min-width: 120px;
  max-width: calc(100% - 20px);
}

/* textarea 特殊处理 - 项目情况描述 */
.two-column-form :deep(.ant-form-item-control textarea.ant-input),
.two-column-form :deep(textarea.ant-input),
.create-form-modal :deep(textarea.ant-input),
.create-form-modal .two-column-form :deep(textarea.ant-input),
.create-form-modal :deep(.ant-form-item[name="description"] textarea.ant-input),
.create-form-modal :deep(.ant-form-item[name="description"] .ant-input) {
  width: 100% !important;
  min-width: 120px !important;
  max-width: calc(100% - 20px) !important;
  box-sizing: border-box !important;
}

/* 项目地址输入框特殊处理（需要为按钮留空间） */
.address-input-wrapper {
  display: flex !important;
  flex-direction: row !important;
  align-items: stretch !important;
  width: 100% !important;
  max-width: calc(100% - 20px) !important;
  gap: 0 !important;
}

.address-input-wrapper .address-input {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  width: auto !important;
  max-width: none !important;
  margin-right: 0 !important;
}

.address-input-wrapper .map-picker-btn {
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
  white-space: nowrap !important;
  margin-left: 0 !important;
}


.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.save-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.save-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

/* 地图选点按钮样式 */
.map-picker-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.map-picker-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.map-picker-btn:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.map-picker-btn:active {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

/* 输入框样式 - 圆角和边框 */
.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-input:hover),
.two-column-form :deep(.ant-input:focus),
.create-form-modal :deep(.ant-input),
.create-form-modal :deep(.ant-input:hover),
.create-form-modal :deep(.ant-input:focus) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-input-affix-wrapper),
.two-column-form :deep(.ant-input-affix-wrapper:hover),
.two-column-form :deep(.ant-input-affix-wrapper-focused),
.create-form-modal :deep(.ant-input-affix-wrapper),
.create-form-modal :deep(.ant-input-affix-wrapper:hover),
.create-form-modal :deep(.ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.two-column-form :deep(.ant-input-affix-wrapper .ant-input),
.create-form-modal :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.two-column-form :deep(.ant-select-selector),
.two-column-form :deep(.ant-select-selector:hover),
.two-column-form :deep(.ant-select-focused .ant-select-selector),
.create-form-modal :deep(.ant-select-selector),
.create-form-modal :deep(.ant-select-selector:hover),
.create-form-modal :deep(.ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-picker:hover),
.two-column-form :deep(.ant-picker-focused),
.create-form-modal :deep(.ant-picker),
.create-form-modal :deep(.ant-picker:hover),
.create-form-modal :deep(.ant-picker-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-input-number),
.two-column-form :deep(.ant-input-number:hover),
.two-column-form :deep(.ant-input-number-focused),
.create-form-modal :deep(.ant-input-number),
.create-form-modal :deep(.ant-input-number:hover),
.create-form-modal :deep(.ant-input-number-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 所有 primary 按钮样式 */
.create-form-modal :deep(.ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.create-form-modal :deep(.ant-btn-primary:hover) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.create-form-modal :deep(.ant-btn-primary:focus) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.create-form-modal :deep(.ant-btn-primary:active) {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 100px 16px !important;
}
</style>
